import { render, staticRenderFns } from "./LoadingShowText.vue?vue&type=template&id=0b76b2fe&scoped=true"
import script from "./LoadingShowText.vue?vue&type=script&lang=ts"
export * from "./LoadingShowText.vue?vue&type=script&lang=ts"
import style0 from "./LoadingShowText.vue?vue&type=style&index=0&id=0b76b2fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b76b2fe",
  null
  
)

export default component.exports